import { render, staticRenderFns } from "./aiNews.vue?vue&type=template&id=0f2d8ac3&scoped=true"
import script from "./aiNews.vue?vue&type=script&setup=true&lang=js"
export * from "./aiNews.vue?vue&type=script&setup=true&lang=js"
import style0 from "./aiNews.vue?vue&type=style&index=0&id=0f2d8ac3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2d8ac3",
  null
  
)

export default component.exports